import { render, staticRenderFns } from "./OfertaTitulo.vue?vue&type=template&id=2356dc7a"
import script from "./OfertaTitulo.vue?vue&type=script&lang=js"
export * from "./OfertaTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2356dc7a')) {
      api.createRecord('2356dc7a', component.options)
    } else {
      api.reload('2356dc7a', component.options)
    }
    module.hot.accept("./OfertaTitulo.vue?vue&type=template&id=2356dc7a", function () {
      api.rerender('2356dc7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OfertaTitulo.vue"
export default component.exports